import { useScript } from "@bokio/hooks/useScript/useScript";

export const TaboolaPixel = () => {
	useScript("scripts/TaboolaPixel.js");

	return null;
};
